import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

const MainWrapper = ({ children }) => {
  return <S.MainWrapper>{children}</S.MainWrapper>
}

MainWrapper.defaultProps = {
  children: {},
}

MainWrapper.propTypes = {
  children: PropTypes.object,
}

export default MainWrapper
